import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useViewport } from '@sbt-web/hooks';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';
import { useAdvToggle } from '@/client/hooks/useAdvToggle';
const SESSION_STORAGE_KEY = 'clickInterstitialCounter';
export const useLiraLazyInterstitialForDesktop = () => {
  const $ = _c(7);
  const {
    isDesktop
  } = useViewport();
  const {
    noAdvToggle,
    optimizelyReady
  } = useAdvToggle();
  const [clickInterstitialCounter, setClickInterstitialCounter] = useState(_temp);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setClickInterstitialCounter(_temp2);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleItemClick = t0;
  let t1;
  let t2;
  if ($[1] !== clickInterstitialCounter || $[2] !== isDesktop || $[3] !== noAdvToggle || $[4] !== optimizelyReady) {
    t1 = () => {
      sessionStorage.setItem(SESSION_STORAGE_KEY, clickInterstitialCounter.toString());
      if (isDesktop && clickInterstitialCounter >= 3 && noAdvToggle === "A" && optimizelyReady) {
        window.liraSDKQueue?.push(_temp3);
      }
    };
    t2 = [clickInterstitialCounter, isDesktop, noAdvToggle, optimizelyReady];
    $[1] = clickInterstitialCounter;
    $[2] = isDesktop;
    $[3] = noAdvToggle;
    $[4] = optimizelyReady;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return handleItemClick;
};
function _temp() {
  if (typeof window !== "undefined") {
    return Number.parseInt(sessionStorage.getItem(SESSION_STORAGE_KEY) ?? "0", 10);
  }
  return 0;
}
function _temp2(prevCounter) {
  return prevCounter + 1;
}
function _temp3() {
  window.liraSdk?.fetchLazyLoadAd([LiraContainerIds.listing.interstitialLazy]);
}